export default {"src":"/_next/static/media/home-reorder-banner-icon.ab3f29e6.svg","height":32,"width":36,"blurWidth":0,"blurHeight":0};